<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          rounded
          depressed
          color="primary"
          type="submit"
          :loading="buttonLoading"
          @click="redeemFirstWillFree"
        >
          <span>Redeem free will</span
          ><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <ErrorSnackbar v-model="showError" />
  </v-container>
</template>

<script>
  import { REDEEM_FIRST_WILL_FREE_MUTATION } from '../../constants/graphql/payments';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'RedeemFirstWillFreeOnceOff',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    methods: {
      redeemFirstWillFree() {
        this.buttonLoading = true;

        const testatorId = this.testatorId;
        const paymentPlan = 'ONCE_OFF';

        this.$apollo
          .mutate({
            mutation: REDEEM_FIRST_WILL_FREE_MUTATION,
            variables: {
              testatorId,
              paymentPlan,
            },
          })
          .then(response => {
            if (response.data.redeemFirstWillFree) {
              this.$router.push('/success-payment');
              this.gtm_tracking();
            } else {
              this.displayError();
            }
            this.buttonLoading = false;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      gtm_tracking() {
        this.$gtm.trackEvent({
          event: 'successful-payment',
          category: 'Payment',
          action: 'First will free',
          value: 0,
        });
      },
    },
  };
</script>
